import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

export interface RecalculatePrizesResponse {
  success: boolean;
  created: number;
  skipped: boolean;
  message?: string;
}

export async function recalculatePrizes(pickemId: string): Promise<RecalculatePrizesResponse> {
  return api.post(`/pickems/${pickemId}/recalculate-prizes`);
}

export function useRecalculatePrizesMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: recalculatePrizes,
    onSuccess: (data, pickemId) => {
      if (data.skipped) {
        toast.info('No payout template assigned to this pickem');
      } else if (data.created > 0) {
        toast.success(`Created ${data.created} prize payout records`);
      } else {
        toast.info('No prize payouts to create');
      }
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: queryKeys.prizePayouts.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.leaderboard.pickem(pickemId) });
    },
    onError: (error: Error) => {
      toast.error(`Failed to calculate prizes: ${error.message}`);
    },
  });
}
